import { Loader } from "@/UI"
import { ProviderDetailsRow, ProviderTableRowHeader } from "./ProviderDetailsRow"
import { ProvidersType } from "@/types/providers.types"
import { useRecoilValue } from "recoil"
import { userAtom } from "@/atoms/userAtom"
import { PROVIDER_DETAILS } from "@/constants/providerDetails"
import {
  IOrganizationProvider,
  IProviderDetails,
  ProviderConfig,
} from "@/types/organization-providers"
import { useOrg } from "@/hooks/useOrg"
import { useState } from "react"
import React from "react"

interface IProvidersList {
  id: string
  isLoading: boolean
  providers: {
    provider: ProvidersType
    fields: any
  }[]
  orgProviders: IOrganizationProvider[]
  updateSingleOrganizationProvider: (orgProvider: IOrganizationProvider) => void
  removeOrgProvider: (id: string) => Promise<any>
  deliveryTypesFilter: (deliveryType: IProviderDetails | null | undefined) => boolean
}

const ProvidersList: React.FC<IProvidersList> = ({
  id,
  isLoading,
  providers,
  orgProviders,
  updateSingleOrganizationProvider,
  removeOrgProvider,
  deliveryTypesFilter,
}) => {
  const user = useRecoilValue(userAtom)
  const { preference } = user
  const { updateOrgPreferences } = useOrg()
  const [loadingSwitch, setLoadingSwitch] = useState<string | null>(null)

  const handleToggleProvider = async (providerName: ProvidersType) => {
    setLoadingSwitch(providerName)
    let newExcludedProviders = preference?.excludeProviderType ?? []
    const index = newExcludedProviders.findIndex(
      (excludedProvider) => excludedProvider === providerName
    )

    if (index < 0) {
      newExcludedProviders = [...newExcludedProviders, providerName]
    } else {
      newExcludedProviders = newExcludedProviders.filter(
        (excludedProvider) => excludedProvider !== providerName
      )
    }
    try {
      await updateOrgPreferences({
        ...user.preference,
        excludeProviderType: newExcludedProviders,
      })
    } catch (error) {
      console.log(error, "Error updating preferences")
    } finally {
      setLoadingSwitch(null)
    }
  }

  return (
    <div id={id} className="flex flex-col mt-3 space-y-2">
      <ProviderTableRowHeader />
      {isLoading ? (
        <Loader fontSize={40} size="small" />
      ) : (
        providers
          ?.sort((a, b) => {
            if (a.provider < b.provider) {
              return -1
            }
            return 1
          })
          ?.map((config, index) => {
            const isProviderEnabled = !preference?.excludeProviderType?.find(
              (excludedProviders) => excludedProviders === config.provider
            )
            const currentOrgProvider = orgProviders?.find(
              (orgProvider: any) => config.provider === orgProvider.provider
            )
            var orgProviderDetail: IProviderDetails | null | undefined
            try {
              orgProviderDetail = JSON.parse(
                JSON.stringify(
                  PROVIDER_DETAILS?.find(
                    (providerDetail) =>
                      config.provider === providerDetail.name && deliveryTypesFilter(providerDetail)
                  )
                )
              ) as IProviderDetails
            } catch (error) {
              return <></>
            }

            if (!orgProviderDetail) return <></>

            orgProviderDetail.authConfig = config as ProviderConfig

            return (
              <ProviderDetailsRow
                id={`${id}-row-${index}`}
                key={config.provider}
                providerDetails={orgProviderDetail}
                handleToggleProvider={() => handleToggleProvider(config.provider)}
                isProviderEnabled={isProviderEnabled}
                isLoading={loadingSwitch === config.provider}
                isDisabled={!!loadingSwitch}
                orgProvider={currentOrgProvider}
                updateSingleOrganizationProvider={updateSingleOrganizationProvider}
                removeOrgProvider={removeOrgProvider}
              />
            )
          })
      )}
    </div>
  )
}

export default ProvidersList
